import { Component } from '@angular/core';
import { InstallNewBinComponent } from '../install-new-bin/install-new-bin.component';

@Component({
  selector: 'app-swap-unit',
  standalone: true,
  imports: [InstallNewBinComponent],
  templateUrl: './swap-unit.component.html',
  styleUrl: './swap-unit.component.scss'
})
export class SwapUnitComponent {
  isSwap: any = true;

  constructor() {}

  ngOnInit() {
  }
}
